import React from "react";
import Footer from "./Footer";
import parentingHeaderImg from "../assets/PositiveParentingHeader.jpg";
import mobileParentingHeaderImg from "../assets/mobilePositiveParentingHeader.jpg";
import tabParentingHeaderImg from "../assets/tabPositiveParentingHeader.jpg";
import FirstSection from "./ParentingTips/FirstSection";
import ParentingSeminar from "./ParentingTips/ParentingSeminar";
import PreLoadingImages from "./custom/PreLoadingImages";
const ParentingTips = () => {
  return (
    <div className="relative">
      <PreLoadingImages
        images={[parentingHeaderImg, mobileParentingHeaderImg, tabParentingHeaderImg]}
      />
      <img
        src={
          window.innerWidth < 450
            ? mobileParentingHeaderImg
            : window.innerWidth < 900
            ? tabParentingHeaderImg
            : parentingHeaderImg
        }
        alt="positive parenting"
        className="overflow-x-hidden w-[100vw] h-[250px] sm:h-[420px] "
      />
      <div className="flex flex-col gap-8 ">
        {/* main img */}

        <FirstSection />
        <ParentingSeminar />

        {/* Footer */}
        <div>
          <Footer marginX={"4%"} />
        </div>
      </div>
    </div>
  );
};

export default ParentingTips;
